import { render, staticRenderFns } from "./PageStructureSectionColorsNewV2.vue?vue&type=template&id=0d78afa0&"
import script from "./PageStructureSectionColorsNewV2.vue?vue&type=script&lang=ts&"
export * from "./PageStructureSectionColorsNewV2.vue?vue&type=script&lang=ts&"
import style0 from "./PageStructureSectionColorsNewV2.vue?vue&type=style&index=0&id=0d78afa0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports